<div class="responsive-card">
  <div class="d-flex flex-column gap-4">
    <div class="d-flex flex-column gap-3">
      <div class="responsive-card-title" i18n>Withdrawal Instructions</div>
      <div class="responsive-card-description" i18n>
        Specify how much to withdraw from each Investment Fund to make up the payment.
      </div>
    </div>
    <ng-container *ngIf="!!formGroup">
      <div class="percentage-input-container" [formGroup]="formGroup">
        <ng-container formArrayName="instructions">
          <ng-container
            *ngFor="let allocation of formGroup.controls.instructions.controls; let first = first"
            [formGroup]="allocation">
            <app-vb-withdrawal-percent-field
              formControlName="percentage"
              [first]="first"
              [fundType]="allocation.controls.fund.getRawValue() | fundTypeById : (fundTypes$ | async)"
              [balance]="allocation.controls.balance?.getRawValue()" />
          </ng-container>
        </ng-container>
        <div class="total-container">
          <div class="d-flex justify-content-between">
            <div class="total-label" i18n>Total</div>
            <div class="total-label">{{ percentageTotal }}%</div>
          </div>
          <div *ngIf="formGroup.controls.instructions?.invalid && formSubmitted" class="form-error" i18n>
            Percentage of investments between accounts must equal 100.00%.
          </div>
        </div>
      </div>
    </ng-container>
    <div class="d-flex justify-content-end">
      <app-button [type]="ButtonTypeEnum.secondary" (buttonClick)="valuesCleared.emit()" i18n>
        Clear Values
      </app-button>
    </div>
  </div>
</div>
